import { Notification } from "../../model/Notifications";
import { http } from "../../utils/http";


export interface ViewNotificationDTO {
    notificationId : number
    email : string

}
export const getNotificationAsync = async(
    userEmail : string,
    token : string
) : Promise<Notification[]> => {
    const result = await http<undefined,Notification[]> ({
        path : `Notification?email=${userEmail}`,
        accessToken : token
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || []
    }
    return []
}

export const deleteNotificationAsync = async (
    notificationId: number,
    userEmail: string,
    token: string
) : Promise<boolean> => {
    const result = await http<undefined, undefined>({
        method: 'delete',
        path: `Notification?notificationID=${notificationId}&email=${userEmail}`,
        accessToken: token
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || null
    }
    return result.ok
}

export const viewNotificationAsync = async (
    viewedNotificationDTO : ViewNotificationDTO,
    token : string,
) : Promise<boolean>  => {
    const result = await http< ViewNotificationDTO, null>({
        method :'post',
        path : 'Notification',
        accessToken : token,
        body : viewedNotificationDTO
    })
    return result.ok

}

